import { render, staticRenderFns } from "./signup-block.vue?vue&type=template&id=eff10f72&"
import script from "./signup-block.vue?vue&type=script&lang=js&"
export * from "./signup-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports